module.exports = __webpack_public_path__ + "vn.f42f933c96b9dda789ff.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/vn.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/vn.svg
// module chunks = styles